import { Component, OnInit } from '@angular/core';
import {GeneralService} from "../services/general.service";
import {DateService} from "../services/date.service"
@Component({
  selector: 'app-param-heur',
  templateUrl: './param-heur.component.html',
  styleUrls: ['./param-heur.component.scss']
})
export class ParamHeurComponent implements OnInit
{
  constructor(public generalService: GeneralService, public dateService : DateService) { }
  data;
  dataBrut;
  disabledBtnEnregistrer : boolean = false;
  exist : boolean = true;
  ngOnInit() 
  {
    this.data={}
    this.getParamHeure();
  }
  enregistrer(f)
  {
    if (f.form.valid) 
    {
      this.disabledBtnEnregistrer = true;
      this.exist = false;
      var url = this.generalService.urlParamHeure;
      if(this.data.AvtHeure_Id>0)
      url =this.generalService.urlParamHeure  + "&val=" + this.data.AvtHeure_Id
      this.generalService.rechercheTable(url).subscribe(dataBrut => 
      {
        dataBrut.avtHeureParam[0].avtHeureAM_Deb = this.data.avtHeureAM_Deb;
        dataBrut.avtHeureParam[0].avtHeureAM_Fin = this.data.avtHeureAM_Fin;
        dataBrut.avtHeureParam[0].avtHeurePM_Deb = this.data.avtHeurePM_Deb;
        dataBrut.avtHeureParam[0].avtHeurePM_Fin = this.data.avtHeurePM_Fin;
        dataBrut.avtHeureParam[0].avtHeure_Ecart = this.data.avtHeure_Ecart;
        this.generalService.enregisterTable(dataBrut).subscribe(data => 
        {
          this.disabledBtnEnregistrer = false;
          this.exist = true;
          this.generalService.dialogSuccess("Enregistré",true);
          this.dateService.setParamHeur();
        },
        err =>
        {
          this.exist = true;
          this.generalService.dialogSuccess("Non enregistré",true);
          this.disabledBtnEnregistrer = false;
        })
      },
      err =>
      {
        this.exist = true;
        this.generalService.dialogSuccess("Non enregistré",true);
        this.disabledBtnEnregistrer = false;
      });
    }
  }
  getParamHeure()
  {
    this.generalService.rechercheTable(this.generalService.urlListeParamHeure).subscribe(data => 
    {
      if(data.length > 0)
      this.data = data[0]
    })
  }

}